import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";
import { ref } from "vue";
const firstPageIndex = 1;
export default /*@__PURE__*/ _defineComponent({
    __name: 'Pagination',
    props: {
        startIndex: { type: Number, required: true },
        currentItemCount: { type: Number, required: true },
        itemsPerPage: { type: Number, required: true },
        totalItems: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const router = useRouter();
        const route = useRoute();
        const currentIndex = (__props.startIndex >= 1 || __props.startIndex <= __props.totalItems) ? __props.startIndex : 1;
        const currentPage = ref(Math.floor((currentIndex - 1) / __props.itemsPerPage) + 1);
        const lastPage = Math.ceil(__props.totalItems / __props.itemsPerPage);
        const lastPageIndex = (lastPage - 1) * __props.itemsPerPage + 1;
        const isFirstPage = currentIndex === firstPageIndex;
        const isLastPage = currentIndex >= lastPageIndex;
        async function onChangePageNumber(event) {
            if (isNaN(currentPage.value) || currentPage.value < 1) {
                currentPage.value = 1;
            }
            else if (currentPage.value > lastPage) {
                currentPage.value = lastPage;
            }
            await router.push({
                query: {
                    ...route.query,
                    ...{
                        startIndex: (currentPage.value - 1) * __props.itemsPerPage + 1,
                    }
                }
            });
        }
        const __returned__ = { $t, router, route, currentIndex, firstPageIndex, currentPage, lastPage, lastPageIndex, isFirstPage, isLastPage, onChangePageNumber, get ChevronDoubleLeftIcon() { return ChevronDoubleLeftIcon; }, get ChevronDoubleRightIcon() { return ChevronDoubleRightIcon; }, get ChevronLeftIcon() { return ChevronLeftIcon; }, get ChevronRightIcon() { return ChevronRightIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
